import { useCallback, useMemo, useState } from "react";
import type { UseMarkerNotesVisibility } from "./types";

export const useMarkerNotesVisibility: UseMarkerNotesVisibility = ({
  byGroupId,
}) => {
  const [areNotesVisible, setAreNotesVisible] = useState(true);

  const toggleNotesVisibility = useCallback(
    () => setAreNotesVisible((current) => !current),
    [],
  );

  const notesCount = useMemo(() => {
    let count = 0;
    for (const elements of Object.values(byGroupId)) {
      for (const element of elements) if (element.note !== null) count += 1;
    }
    return count;
  }, [byGroupId]);

  return { notesCount, areNotesVisible, toggleNotesVisibility };
};
